import React from "react";
import moment from "moment/moment";
import { t } from "i18next";
import {
   Button,
   Drawer,
   Spin,
   InputTextArea,
   PaperClipOutlined
} from "common/elements";
import {
   Approved,
   Rejected,
   Pending,
   Cancelled
} from "common/status";
import { Util } from "common/util";
import {
   updateStatus,
   cancelApprovedLeave,
   getOne,
} from "services/leave";
import Enum from "common/enums";
import { getHostURl } from 'services/core';

function RowItem({ title, value }) {
   return <div style={{ display: "flex", justifyItems: "center", justifyContent: "space-between", marginTop: 5 }}>
      <div className="ant-form-item-label" style={{ width: 165 }}>
         <label>{title}</label>
      </div>
      <div style={{ border: "1px solid #d9d9d9", borderRadius: 4, height: 32, lineHeight: "32px", flexGrow: 1, paddingLeft: 10 }}>
         {value}
      </div>
   </div>
}

const status = {
   [Enum.LEAVESTATUS.REQUESTED]: <Pending />,
   [Enum.LEAVESTATUS.APPROVED]: <Approved />,
   [Enum.LEAVESTATUS.REJECTED]: <Rejected />,
   [Enum.LEAVESTATUS.CANCELLED]: <Cancelled />
};

export default class FormReview extends React.Component {
   state = {
      loading: false,
      visible: false,
      formData: {},
      comment: "",
      commentStatus: ""
   };

  

   componentDidMount() {
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has("leaveId")) {
         this.showDrawer(queryParams.get("leaveId"));
      };
   }

   showDrawer = (id) => {
      this.setState({ loading: true, visible: true });
      getOne(id)
         .then((response) => {
            if (response.data) {
               this.setState({
                  formData: response.data,
                  loading: false,
               });
            }
         })
         .catch(error => {
            if (error.response.status === 403) {
               localStorage.removeItem("ACCESS_TOKEN");
               this.props.navigate("/signin");
            }
         })
         .finally(() => {
            this.setState({ loading: false });
         });
   };

   onClose = () => {
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has("leaveId")) {
         queryParams.delete("leaveId");
         Util.getInstance().pushParamsToURL("/leaves", queryParams.toString());
      };
      this.setState({
         visible: false,
         loading: false,
         formData: {}
      });
   };

   onFinish = (values) => {
      this.handleUpdateStatusButton(
         this.state.formData.id,
         Enum.LEAVESTATUS.REJECTED,
         values
      );
   };

   handleApprove = () => {
      Util.getInstance()
         .sweetAlertConfirm(t("text_confrim"), "Once approved, you will not be able to rollback this leave!")
         .then((willApprove) => {
            if (willApprove) {
               this.setState({
                  submitting: true
               });
               updateStatus({
                  leaveRequestId: this.state.formData.id,
                  status: Enum.LEAVESTATUS.APPROVED,
                  startShift: this.state.formData.startShift,
                  endShift: this.state.formData.endShift
               })
                  .then(() => {
                     this.props.onSuccess();
                     window.location.reload();
                     this.onClose();
                  })
                  .finally(() => {
                     this.setState({
                        submitting: false,
                        visible: false
                     });
                  });
            }
         });
   };

   handleReject = () => {
      if (!this.state.comment) {
         this.setState({ commentStatus: "ant-input-status-error" });
         return;
      }

      Util.getInstance()
         .sweetAlertConfirm(t("text_confrim"), "Once rejected, you will not be able to rollback this leave!")
         .then((willReject) => {
            if (willReject) {
               this.setState({ rejecting: true });

               updateStatus({
                  leaveRequestId: this.state.formData.id,
                  status: Enum.LEAVESTATUS.REJECTED,
                  comment: this.state.comment,
                  startShift: this.state.formData.startShift,
                  endShift: this.state.formData.endShift
               })
                  .then(() => {
                     this.props.onSuccess();
                     window.location.reload();
                     this.onClose();
                  })
                  .finally(() => {
                     this.setState({
                        rejecting: false
                     });
                  });
            }
         });
   };

   // handleCancel = () => {
   //    Util.getInstance()
   //       .sweetAlertConfirm(t("text_confrim"), "Once cancelled, you will not be able to rollback this leave!")
   //       .then((willApprove) => {
   //          if (willApprove) {
   //             this.setState({
   //                submitting: true
   //             });
   //             cancelApprovedLeave(this.state.formData.id)
   //                .then(() => {
   //                   this.props.onSuccess();
   //                   this.onClose();
   //                })
   //                .finally(() => {
   //                   this.setState({
   //                      submitting: false,
   //                      visible: false
   //                   });
   //                });
   //          }
   //       });
   // };

   render() {
      const {
         visible,
         formData,
         rejecting,
         submitting,
         loading
      } = this.state;
      const employeeCode = JSON.parse(localStorage.getItem("ACCESS_TOKEN")).profile.code;
      return <>
         <Drawer
            placement="right"
            id="leave-drawer"
            closable={true}
            visible={visible}
            onClose={this.onClose}
            width={600}
            title={
               <div style={{ display: "flex" }}>
                  <div style={{ marginRight: 15 }}>Leave Request</div>
                  {status[formData.status]}
               </div>
            }
         >
            {
               loading ? <Spin spinning={loading} className="leave-loading"></Spin> : Object.keys(formData).length === 0 ? <></>
                  :
                  <>
                     <div style={{ height: document.documentElement.offsetHeight - 110, overflowY: "auto", paddingLeft: 25, paddingRight: 25 }}>
                        <div style={{ marginTop: 25 }} />
                        <RowItem title={t("text_request_no")} value={formData.requestNo} />
                        <RowItem title={t("text_staff_id")} value={formData.employeeCode} />
                        <RowItem title={t("text_staff_name")} value={formData.employeeName} />
                        <RowItem title={t("text_staff_email_id")} value={formData.staffEmailId} />
                        <RowItem title={t("text_type_of_leave")} value={formData.leaveName} />
                        <RowItem title={t("text_leave_from")} value={moment(formData.start).format("ddd DD MMM, YYYY")} />
                        <RowItem title={t("text_leave_to")} value={moment(formData.end).format("ddd DD MMM, YYYY")} />
                        <RowItem title={[Enum.LEAVE_TYPE.MATERNITY, Enum.LEAVE_TYPE.PATERNITY_LEAVE].includes(formData.type) ? "Number of Weeks" : t("text_number_day")} value={formData.numberOfDay} />
                        {formData.reason &&
                           <div style={{ display: "flex", justifyItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                              <div className="ant-form-item-label" style={{ width: 165, display: "flex", alignItems: "center" }}>
                                 <label>{t("text_reason")}</label>
                              </div>
                              <div style={{ border: "1px solid #d9d9d9", borderRadius: 4, height: 100, flexGrow: 1, paddingLeft: 10, paddingTop: 5 }}>
                                 {formData.reason}
                              </div>
                           </div>
                        }
                        <RowItem title={t("text_requested_date")} value={moment(formData.requestedDate).format("ddd DD MMM, YYYY")} />
                        {
                           formData.attachment && <RowItem title={t("text_attachment")} value={<a target="_blank" rel="noopener noreferrer" key="1" href={`${getHostURl()}/public/uploads/leaves/${formData.employeeId}/${formData.attachment}`}><PaperClipOutlined /><span> {formData.attachment.split("/").pop()}</span></a>} />
                        }
                        <RowItem title={t("text_approval_id")} value={formData.userName} />
                        {
                           ![Enum.LEAVE_TYPE.UNPAID_LEAVE, Enum.LEAVE_TYPE.SICK_LEAVE, Enum.LEAVE_TYPE.MATERNITY, Enum.LEAVE_TYPE.PATERNITY_LEAVE].includes(formData.type) &&
                           <>
                              <RowItem title={t("text_last_balance")} value={formData.lastBalance} />
                              <RowItem title={t("text_balance_this_leave")} value={formData.balanceThisLeave} />
                           </>
                        }
                        {
                           [Enum.LEAVESTATUS.REQUESTED, Enum.LEAVESTATUS.REJECTED].includes(formData.status) &&
                           <div className="form-input">
                              <div className="ant-form-item-label" style={{ width: 165 }}>
                                 <label className="ant-form-item-required">{t("text_hr_comment")}</label>
                              </div>
                              <div style={{ flexGrow: 1 }}>
                                 <InputTextArea
                                    name="comment"
                                    className={this.state.commentStatus}
                                    defaultValue={formData.comment}
                                    requiredMessage={t("text_what_is_your_reject_reason")}
                                    placeholder={t("text_tell_requestor_about_rejected_reason_here")}
                                    onChange={e => this.setState({ comment: e.target.value, commentStatus: "" })}
                                    style={{ height: 136 }}
                                 />
                                 {
                                    this.state.commentStatus &&
                                    <div className="ant-form-item-explain">
                                       <div role="alert" className="ant-form-item-explain-error">Please enter your rejected reason!</div>
                                    </div>
                                 }
                              </div>
                           </div>
                        }
                     </div>
                     {
                        employeeCode !== formData.employeeCode &&
                        <div id="leave-btn" className="btn-footer" style={{ display: "flex", justifyContent: "flex-end" }}>
                           {
                              formData.status === Enum.LEAVESTATUS.REQUESTED && !Util.getInstance().hasNoPermission("approve", "leave request") &&
                              <Button
                                 className="btn-form btn-rejected"
                                 onClick={this.handleReject}
                                 loading={rejecting}
                                 disabled={submitting || rejecting}
                                 style={{ width: 130 }}
                              >
                                 {t("text_reject")}
                              </Button>
                           }

                           {
                              formData.status === Enum.LEAVESTATUS.REQUESTED && !Util.getInstance().hasNoPermission("approve", "leave request") &&
                              <Button
                                 className="btn-form btn-approved"
                                 type="primary"
                                 onClick={this.handleApprove}
                                 loading={submitting}
                                 disabled={submitting || rejecting}
                                 style={{ width: 130 }}
                              >
                                 {t("text_approve")}
                              </Button>

                           }

                           {/* {
                              formData.status === Enum.LEAVESTATUS.APPROVED && !Util.getInstance().hasNoPermission("cancel", "leave request") &&
                              <Button
                                 className="btn-form btn-rejected"
                                 onClick={this.handleCancel}
                                 loading={rejecting}
                                 disabled={submitting || rejecting}
                                 style={{ width: 130 }}
                              >
                                 Cancel
                              </Button>
                           } */}
                        </div>
                     }
                  </>
            }
         </Drawer>
      </>;
   }
}
